import { MarketActivityIndicator, MarketEmptyState } from '@market/react';

import styles from 'typescript/apps/checkout_v3/components/loading_state.module.scss';

export const LOADING_INDICATOR_TEST_ID = 'loading-indicator';

type LoadingStateProps = {
  indicatorSize?: HTMLMarketActivityIndicatorElement['size'];
};

// A loading indicator component that displays a spinner while loading.
// It fills the parent container with a spinner.
export const LoadingState = ({ indicatorSize }: LoadingStateProps) => {
  return (
    <MarketEmptyState
      data-testid={LOADING_INDICATOR_TEST_ID}
      className={styles.loadingIndicator}
    >
      <MarketActivityIndicator slot="actions" size={indicatorSize} />
    </MarketEmptyState>
  );
};
